export const messages = {
  en: {
    orgManage: {
      queryCondition: 'Query Conditions',
      staffNamePlaceholder: 'Please enter staff name',
      query: 'Query',
      staff: 'Staff',
      relateStaff: 'Relate Staff',
      name: 'Name',
      phone: 'Phone',
      position: 'Position',
      email: 'Email',
      address: 'Address',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      operation: 'Operation',
      delete: 'Delete',
      detail: 'Detail',
      selectOrgFirst: 'Please select organization first'
    },
    orgTree: {
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      selectOrgFirst: 'Please select organization first'
    },
    addOrg: {
      title: 'Add Organization',
      orgName: 'Organization Name',
      orgNamePlaceholder: 'Required, please enter organization name',
      orgNameRequired: 'Organization name is required',
      orgNameLength: 'Organization name length should be 2-50 characters',
      parentOrg: 'Parent Organization',
      parentOrgPlaceholder: 'Required, please enter parent organization',
      parentOrgRequired: 'Parent organization is required',
      description: 'Description',
      descriptionPlaceholder: 'Required, please enter description',
      descriptionLength: 'Description cannot exceed 200 characters',
      save: 'Save',
      cancel: 'Cancel',
      saveSuccess: 'Save successfully'
    },
    editOrg: {
      title: 'Edit Organization',
      orgName: 'Organization Name',
      orgNamePlaceholder: 'Required, please enter organization name',
      orgNameRequired: 'Organization name is required',
      orgNameLength: 'Organization name length should be 2-50 characters',
      parentOrg: 'Parent Organization',
      parentOrgPlaceholder: 'Required, please enter parent organization',
      parentOrgRequired: 'Parent organization is required',
      description: 'Description',
      descriptionPlaceholder: 'Required, please enter description',
      descriptionLength: 'Description cannot exceed 200 characters',
      orgIdRequired: 'Organization ID is required',
      save: 'Save',
      cancel: 'Cancel',
      saveSuccess: 'Save successfully'
    },
    deleteOrg: {
      title: 'Confirm Operation',
      confirmDelete: 'Confirm to delete organization?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteSuccess: 'Delete successfully'
    },
    orgRelStaff: {
      title: 'Relate Staff',
      staffNamePlaceholder: 'Please enter staff name',
      query: 'Query',
      reset: 'Reset',
      staffName: 'Staff Name',
      staffPhone: 'Staff Phone',
      staffId: 'Staff ID',
      close: 'Close',
      submit: 'Submit',
      selectStaffFirst: 'Please select staff first',
      saveSuccess: 'Relate successfully'
    },
    deleteOrgRelStaff: {
      title: 'Confirm Operation',
      confirmDelete: 'Confirm to delete organization staff relation?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    orgManage: {
      queryCondition: '查询条件',
      staffNamePlaceholder: '请输入员工名称',
      query: '查询',
      staff: '员工',
      relateStaff: '关联员工',
      name: '名称',
      phone: '手机号',
      position: '岗位',
      email: '邮箱',
      address: '地址',
      gender: '性别',
      male: '男',
      female: '女',
      operation: '操作',
      delete: '删除',
      detail: '详情',
      selectOrgFirst: '请先选择组织'
    },
    orgTree: {
      add: '添加',
      edit: '修改',
      delete: '删除',
      selectOrgFirst: '请先选择组织'
    },
    addOrg: {
      title: '添加组织',
      orgName: '组织名称',
      orgNamePlaceholder: '必填，请填写组织名称',
      orgNameRequired: '组织名称不能为空',
      orgNameLength: '组织名称长度为2至50',
      parentOrg: '上级组织',
      parentOrgPlaceholder: '必填，请填写上级组织',
      parentOrgRequired: '上级ID不能为空',
      description: '描述',
      descriptionPlaceholder: '必填，请填写描述',
      descriptionLength: '描述不能为空',
      save: '保存',
      cancel: '取消',
      saveSuccess: '保存成功'
    },
    editOrg: {
      title: '修改组织',
      orgName: '组织名称',
      orgNamePlaceholder: '必填，请填写组织名称',
      orgNameRequired: '组织名称不能为空',
      orgNameLength: '组织名称长度为2至50',
      parentOrg: '上级组织',
      parentOrgPlaceholder: '必填，请填写上级组织',
      parentOrgRequired: '上级ID不能为空',
      description: '描述',
      descriptionPlaceholder: '必填，请填写描述',
      descriptionLength: '描述不能为空',
      orgIdRequired: '组织ID不能为空',
      save: '保存',
      cancel: '取消',
      saveSuccess: '保存成功'
    },
    deleteOrg: {
      title: '请确认您的操作',
      confirmDelete: '确定删除组织管理?',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功'
    },
    orgRelStaff: {
      title: '关联员工',
      staffNamePlaceholder: '请输入员工名称',
      query: '查询',
      reset: '重置',
      staffName: '员工名称',
      staffPhone: '员工电话',
      staffId: '员工编号',
      close: '关闭',
      submit: '提交',
      selectStaffFirst: '未选择员工',
      saveSuccess: '关联成功'
    },
    deleteOrgRelStaff: {
      title: '请确认您的操作',
      confirmDelete: '确定删除组织管理?',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}